import React, { useState } from "react"
import { useForm } from "react-better-hook-form"
import { Link } from "react-router-dom"
import { mdiFacebook, mdiInstagram, mdiLinkedin } from "@mdi/js"
import Icon from "@mdi/react"

import emailjs from "emailjs-com"

import "../style/Contact.scss"
import { PageLanding } from "../components"
import { getText } from "../redux"
import { useSelector } from "react-redux"
import { splitText } from "../utils"
import { Helmet } from "react-helmet"

function Contact() {
	const { handleChange, checkErrors, errors, data } = useForm({
		default: {},
		reqs: {
			name: {
				required: true,
				max: { value: 256 },
			},
			email: {
				required: true,
				email: true,
				max: { value: 256 },
			},
			phone: {
				required: true,
				max: { value: 15 },
			},
			message: {
				required: true,
				min: { value: 10 },
				max: { value: 2000 },
			},
		},
	})

	const sectionData = useSelector(state => getText(state, "contact"))

	const [agreedPolicy, setAgreedPolicy] = useState(false)
	const [policyError, setPolicyError] = useState("")

	const handleSubmit = ev => {
		ev.preventDefault()

		const nameInput = document.querySelector("#formName")
		const emailInput = document.querySelector("#formEmail")
		const phoneInput = document.querySelector("#formPhone")
		const messageInput = document.querySelector("#formMessage")

		if (!data.name || errors.name) {
			nameInput.style.border = "2px solid red"
		}
		if (!data.email || errors.email) {
			emailInput.style.border = "2px solid red"
		}
		if (!data.phone || errors.phone) {
			phoneInput.style.border = "2px solid red"
		}
		if (!data.message || errors.message) {
			messageInput.style.border = "2px solid red"
		}

		const errorsExist = checkErrors()
		if (errorsExist) {
			return
		}

		if (!agreedPolicy) {
			setPolicyError(
				"Trebuie sa fiti de acord cu politica de confidentialitate"
			)
			return
		} else setPolicyError("")

		sendMail(ev)
	}

	const handleContact = ev => {
		ev.preventDefault()
		window.open("tel:+40747667827")
	}

	const handleInputChange = ev => {
		handleChange(ev)
		ev.target.style.border = "1px solid #ccc"
	}

	const sendMail = ev => {
		ev.preventDefault()

		emailjs
			.sendForm(
				"service_38ttcgv",
				"template_umr9pw5",
				ev.target,
				"user_5ontjkV7Jx0URo3JOc20T"
			)
			.then(
				result => null,
				error => null
			)
	}

	return (
		<>
			<Helmet>
				<title>Contact | Agentie de Web Design - Xposed Agency</title>
				<meta
					name="description"
					content="Contact | Agentie de Web Design - Xposed Agency"
				/>
			</Helmet>

			<PageLanding
				src="https://firebasestorage.googleapis.com/v0/b/xposed-837fc.appspot.com/o/predefined%2Fcontact.jpg?alt=media&token=ee9a14c1-da21-4e94-aaf2-40407356fc7b"
				title="Contact"
			/>
			<div className="contactpage">
				<div className="contactpage__section">
					<div className="section__top">
						<h3>{sectionData.subtitle}</h3>

						<div className="section__top__right">
							<h1>{splitText(sectionData.title)}</h1>

							<div
								className="pageLanding__text__separator"
								style={{ margin: "20px 0" }}
							/>

							<p>{splitText(sectionData.description)}</p>
							<button
								className="contactpage__button contactpage__link"
								onClick={handleContact}
							>
								{sectionData.phone}
							</button>
							<Link className="contactpage__link">{sectionData.email}</Link>
							<div className="contactpage__icons">
								<Link
									className="contactpage__icons__icon"
									to="https://www.facebook.com/xposedromania/"
								>
									<Icon path={mdiFacebook} size={1.2} color="#333" />
								</Link>
								<Link
									className="contactpage__icons__icon"
									to="https://www.linkedin.com/company/xposed-agency"
								>
									<Icon path={mdiLinkedin} size={1.2} color="#333" />
								</Link>
								<Link
									className="contactpage__icons__icon"
									to="https://www.instagram.com/xposedagency/"
								>
									<Icon path={mdiInstagram} size={1.2} color="#333" />
								</Link>
							</div>
						</div>
					</div>
				</div>
				<div className="contactpage__form__container">
					<form
						id="contactForm"
						className="contactpage__form"
						onSubmit={handleSubmit}
					>
						<input
							id="formName"
							name="name"
							onChange={handleInputChange}
							placeholder="Nume si prenume"
						/>
						<input
							id="formEmail"
							type="email"
							name="email"
							onChange={handleInputChange}
							placeholder="Email"
						/>
						<input
							id="formPhone"
							name="phone"
							onChange={handleInputChange}
							placeholder="Numar de telefon"
						/>
						<input
							id="formMessage"
							name="message"
							onChange={handleInputChange}
							placeholder="Spune-ne cum te putem ajuta"
						/>
						<label>
							Asigurati-va ca mesajul are intre 10-2000 de caractere
						</label>

						<div className="contactpage__form__submitarea">
							<div className="checkbox contactpage__form__input">
								<label>
									Am citit si sunt de acord cu{" "}
									<Link
										className="checkbox__link"
										to="/politica-de-confidentialitate"
									>
										<u>politica de confidentialitate</u>
									</Link>
								</label>
								<input
									name="agreedpolicy"
									onChange={() => setAgreedPolicy(!agreedPolicy)}
									type="checkbox"
								/>
							</div>
							<button type="submit">Trimite mesajul</button>
						</div>
						<p className="contactpage__form__error">{policyError}</p>
					</form>
				</div>
			</div>
		</>
	)
}

export default Contact
